import React from "react";
import { Box, CheckboxCard } from "@commonsku/design-system";
import { WorkflowSelectOption } from "../../../../types";

export interface StatusSelectionGridProps {
  options: WorkflowSelectOption[];
  selectedValues: string[];
  onToggle: (value: string) => void;
}

/**
 * Presentational multi-select grid for workflow status-like options.
 */
export const StatusSelectionGrid = ({
  options,
  selectedValues,
  onToggle,
}: StatusSelectionGridProps) => (
  <Box
    display="grid"
    gap="4"
    gridTemplateColumns="repeat(auto-fit, minmax(14rem, 1fr))"
    width="full"
  >
    {options.map((option) => {
      const checked = selectedValues.includes(option.value);

      return (
        <CheckboxCard.Root
          checked={checked}
          colorPalette="neutral"
          key={option.value}
          onCheckedChange={() => onToggle(option.value)}
          size="sm"
          variant="outline"
        >
          <CheckboxCard.HiddenInput />
          <CheckboxCard.Control>
            <CheckboxCard.Content>
              <CheckboxCard.Label>{option.label}</CheckboxCard.Label>
            </CheckboxCard.Content>
            <CheckboxCard.Indicator
              alignSelf="center"
              borderStyle="solid"
              borderWidth="1px"
              colorPalette="brand"
            />
          </CheckboxCard.Control>
        </CheckboxCard.Root>
      );
    })}
  </Box>
);

export default StatusSelectionGrid;
